import React from "react";
import { styled } from "@mui/material/styles";
import {
  Box,
  Dialog,
  DialogContent,
  Typography,
  Grid,
  TextField,
  Button,
} from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import { SubheaderSection } from "../../components";
import { useAxios } from "../../hooks";

// Styled components
const StyledDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialog-paper": {
    borderRadius: "15px",
    background: "#fff",
    [theme.breakpoints.up("sm")]: {
      width: "85%",
    },
    [theme.breakpoints.up("md")]: {
      width: "50%",
    },
    [theme.breakpoints.up("lg")]: {
      width: "35%",
    },
  },
}));

const ContentBox = styled(Box)(({ theme }) => ({
  padding: "30px",
  textAlign: "center",
  background: "#ffffff",
  borderRadius: "15px",
}));

const StyledTextField = styled(TextField)(({ theme }) => ({
  "& .MuiInputBase-root": {
    borderRadius: "10px",
    backgroundColor: "#f8f8f8",
  },
}));

const SubmitButton = styled(Button)(({ theme }) => ({
  backgroundColor: "#3c2ff4",
  color: "#fff",
  borderRadius: "10px",
  textTransform: "none",
  fontWeight: 600,
  fontSize: "16px",
  padding: "12px 0",
  "&:hover": {
    backgroundColor: "#2e23bd",
  },
}));

const AddGuardian = ({ guardian, setGuardian, state }) => {
  const axios = useAxios();

  const formik = useFormik({
    initialValues: {
      gurdian_first_name: "",
      gurdian_last_name: "",
      gurdian_mobile_number: "",
      gurdian_email: "",
      gurdian_badge_id: state?.[0]?.badge_id || "",
      relation: "",
      student_visitor_id: state?.[0]?.student_visitor_id || "",
      campus_id: state?.[0]?.entity_id || "",
    },
    validationSchema: Yup.object({
      gurdian_first_name: Yup.string().required("Required"),
      gurdian_last_name: Yup.string().required("Required"),
      gurdian_mobile_number: Yup.string()
        .matches(/^[0-9]{10}$/, "Must be a 10-digit number")
        .required("Required"),
      gurdian_email: Yup.string().email("Invalid email"),
      gurdian_badge_id: Yup.string(),
      relation: Yup.string(),
    }),
    onSubmit: async (values, { resetForm }) => {
      values.is_dependent =
        state[0].visitor_info.phone_number ===
        "91" + values.gurdian_mobile_number;
      try {
        const response = await axios({
          url: "https://dev.backend-digipass.verismart.ai/v1/notification/notification/add-gurdian",
          method: "POST",
          data: values,
        });
        if (response.status) {
          resetForm();
          setGuardian(false);
        }
      } catch (err) {
        console.error("Submit Error:", err);
      }
    },
  });

  return (
    <StyledDialog
      open={guardian}
      onClose={() => setGuardian(false)}
      fullWidth
      maxWidth="md"
    >
      <DialogContent sx={{ padding: "0px" }}>
        <ContentBox>
          <Typography variant="h5" fontWeight="bold" mb={2}>
            Add Guardian
          </Typography>

          <form onSubmit={formik.handleSubmit} style={{ marginTop: "20px" }}>
            <Grid container spacing={2}>
              {[
                {
                  name: "gurdian_first_name",
                  label: "First Name",
                  required: true,
                },
                {
                  name: "gurdian_last_name",
                  label: "Last Name",
                  required: true,
                },
                {
                  name: "gurdian_mobile_number",
                  label: "Mobile Number",
                  required: true,
                },
                { name: "gurdian_email", label: "Email" },
                { name: "gurdian_badge_id", label: "Badge ID" },
                { name: "relation", label: "Relation" },
              ].map((field) => (
                <Grid item xs={12} key={field.name}>
                  <StyledTextField
                    fullWidth
                    name={field.name}
                    label={field.label}
                    value={formik.values[field.name]}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={
                      formik.touched[field.name] &&
                      Boolean(formik.errors[field.name])
                    }
                    helperText={
                      formik.touched[field.name] && formik.errors[field.name]
                    }
                    disabled={field.name === "gurdian_badge_id"}
                    variant="outlined"
                  />
                </Grid>
              ))}
            </Grid>

            <SubmitButton type="submit" fullWidth sx={{ marginTop: "20px" }}>
              Submit Guardian Info
            </SubmitButton>
          </form>
        </ContentBox>
      </DialogContent>
    </StyledDialog>
  );
};

export default AddGuardian;
